import { CHAT_MESSAGE_PADDING_HORIZONTAL } from '@fruitful/agent-ui';
import React from 'react';
import {
    BodyLargeRegular,
    BodySmallEmphasized,
    H5Emphasized,
    isWeb,
    ScrollView,
    useMedia,
    XStack,
    YStack,
} from 'smoothie';

import { ChatSuggestionPill } from './ChatSuggestionPill';

export const SPROUT_INTRO_COPY = [
    'I can help you with things like searching your transactions for what stands out, summarizing your spending, identifying patterns and trends, and surfacing how your income has been split.',
] as const;

export const SPROUT_DEFAULT_SUGGESTIONS = [
    'Where has my spend been going?',
    'How was my last paycheck split?',
    'How well am I doing with my spend over time?',
] as const;

interface SproutEmptyStateProps {
    greeting?: string;
    introCopy?: readonly string[];
    suggestions: string[];
    onSuggestionPress: (suggestion: string) => void;
}

export const SproutEmptyState = ({
    greeting,
    introCopy,
    suggestions,
    onSuggestionPress,
}: SproutEmptyStateProps) => {
    const breakpoints = useMedia();
    const shouldWrapSuggestions = isWeb && breakpoints.sm;

    const suggestionPills = suggestions.map((suggestion) => (
        <ChatSuggestionPill
            key={suggestion}
            text={suggestion}
            onPress={() => {
                onSuggestionPress(suggestion);
            }}
        />
    ));

    return (
        <YStack paddingVertical="$6" gap="$4">
            <YStack
                paddingHorizontal={CHAT_MESSAGE_PADDING_HORIZONTAL}
                gap="$4"
            >
                {greeting != null && <H5Emphasized>{greeting}</H5Emphasized>}

                {introCopy != null && introCopy.length > 0 ? (
                    <YStack gap="$4">
                        {introCopy.map((paragraph) => (
                            <BodyLargeRegular key={paragraph}>
                                {paragraph}
                            </BodyLargeRegular>
                        ))}
                    </YStack>
                ) : null}
            </YStack>

            {suggestions.length > 0 && (
                <YStack gap="$3">
                    <BodySmallEmphasized
                        paddingHorizontal={CHAT_MESSAGE_PADDING_HORIZONTAL}
                    >
                        Try asking
                    </BodySmallEmphasized>
                    {shouldWrapSuggestions ? (
                        <XStack
                            gap="$3"
                            flexWrap="wrap"
                            paddingHorizontal={CHAT_MESSAGE_PADDING_HORIZONTAL}
                        >
                            {suggestionPills}
                        </XStack>
                    ) : (
                        <ScrollView
                            horizontal
                            showsHorizontalScrollIndicator={false}
                        >
                            <XStack
                                gap="$3"
                                paddingHorizontal={
                                    CHAT_MESSAGE_PADDING_HORIZONTAL
                                }
                            >
                                {suggestionPills}
                            </XStack>
                        </ScrollView>
                    )}
                </YStack>
            )}
        </YStack>
    );
};
